export default __webpack_public_path__ + "locales/fi/Webhooks.json?hash=9435b31ecdd160cd577b910c08316764";